import React, { Component } from "react";

import { ISlackWebhook } from "@formant/core/model/ISlackWebhook";

import { IconButton } from "../../common/IconButton";

export interface ISlackWebhooksRowProps {
    webhook: ISlackWebhook;
    index: number;
    onDelete: (index: number) => void;
}

export class SlackWebhooksRow extends Component<ISlackWebhooksRowProps> {
    public render() {
        const { onEdit, onDelete } = this;
        const {
            webhook: { webhookChannel },
        } = this.props;

        return (
            <tr>
                <td>{webhookChannel}</td>
                <td>
                    <IconButton icon="edit" onClicked={onEdit} />
                    <IconButton icon="delete" onClicked={onDelete} />
                </td>
            </tr>
        );
    }

    private onDelete = () => {
        const { index, onDelete } = this.props;
        onDelete(index);
    };

    private onEdit = () => {
        window.open(this.props.webhook.configurationUrl);
    };
}
